import { ValidationErrorData } from '../typings/common';

export const UPDATE_EDIT_PAGE_ITEM_NAME_EDITOR_VALUE =
    'UPDATE_EDIT_PAGE_ITEM_NAME_EDITOR_VALUE';
export type UPDATE_EDIT_PAGE_ITEM_NAME_EDITOR_VALUE = typeof UPDATE_EDIT_PAGE_ITEM_NAME_EDITOR_VALUE;

export interface UpdateEditPageItemNameEditorValueAction {
    type: UPDATE_EDIT_PAGE_ITEM_NAME_EDITOR_VALUE;
    editorId: string;
    value: string;
}

export function updateEditPageItemNameEditorValue(
    editorId: string,
    value: string
): UpdateEditPageItemNameEditorValueAction {
    return {
        type: UPDATE_EDIT_PAGE_ITEM_NAME_EDITOR_VALUE,
        editorId,
        value
    };
}

export const OPEN_EDIT_PAGE_ITEM_NAME_EDITOR =
    'OPEN_EDIT_PAGE_ITEM_NAME_EDITOR';
export type OPEN_EDIT_PAGE_ITEM_NAME_EDITOR = typeof OPEN_EDIT_PAGE_ITEM_NAME_EDITOR;

export interface OpenEditPageItemNameEditorAction {
    type: OPEN_EDIT_PAGE_ITEM_NAME_EDITOR;
    editorId: string;
    value: string;
}

export function openEditPageItemNameEditor(
    editorId: string,
    value: string
): OpenEditPageItemNameEditorAction {
    return {
        type: OPEN_EDIT_PAGE_ITEM_NAME_EDITOR,
        editorId,
        value
    };
}

export const CANCEL_EDIT_PAGE_ITEM_NAME_EDITOR_CHANGES =
    'CANCEL_EDIT_PAGE_ITEM_NAME_EDITOR_CHANGES';
export type CANCEL_EDIT_PAGE_ITEM_NAME_EDITOR_CHANGES = typeof CANCEL_EDIT_PAGE_ITEM_NAME_EDITOR_CHANGES;

export interface CancelEditPageItemNameEditorChangesAction {
    type: CANCEL_EDIT_PAGE_ITEM_NAME_EDITOR_CHANGES;
    editorId: string;
}

export function cancelEditPageItemNameEditorChanges(
    editorId: string
): CancelEditPageItemNameEditorChangesAction {
    return {
        type: CANCEL_EDIT_PAGE_ITEM_NAME_EDITOR_CHANGES,
        editorId
    };
}

export const CLOSE_EDIT_PAGE_ITEM_NAME_EDITOR =
    'CLOSE_EDIT_PAGE_ITEM_NAME_EDITOR';
export type CLOSE_EDIT_PAGE_ITEM_NAME_EDITOR = typeof CLOSE_EDIT_PAGE_ITEM_NAME_EDITOR;

export interface CloseEditPageItemNameEditorAction {
    type: CLOSE_EDIT_PAGE_ITEM_NAME_EDITOR;
    editorId: string;
}

export function closeEditPageItemNameEditor(
    editorId: string
): CloseEditPageItemNameEditorAction {
    return {
        type: CLOSE_EDIT_PAGE_ITEM_NAME_EDITOR,
        editorId
    };
}

export const SHOW_EDIT_PAGE_ITEM_NAME_EDITOR_ERRORS =
    'SHOW_EDIT_PAGE_ITEM_NAME_EDITOR_ERRORS';
export type SHOW_EDIT_PAGE_ITEM_NAME_EDITOR_ERRORS = typeof SHOW_EDIT_PAGE_ITEM_NAME_EDITOR_ERRORS;

export interface ShowEditPageItemNameEditorErrorsAction {
    type: SHOW_EDIT_PAGE_ITEM_NAME_EDITOR_ERRORS;
    editorId: string;
    errors?: ValidationErrorData[];
}

export function showEditPageItemNameEditorErrors(
    editorId: string,
    errors?: ValidationErrorData[]
): ShowEditPageItemNameEditorErrorsAction {
    return {
        type: SHOW_EDIT_PAGE_ITEM_NAME_EDITOR_ERRORS,
        editorId,
        errors
    };
}

export type EditPageItemNameEditorAction =
    | UpdateEditPageItemNameEditorValueAction
    | OpenEditPageItemNameEditorAction
    | CancelEditPageItemNameEditorChangesAction
    | CloseEditPageItemNameEditorAction
    | ShowEditPageItemNameEditorErrorsAction;
